<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon 
            v-on="{ ...tooltip, ...dialog }"
            @click="setEmail"
            color="orange"
          ><v-icon>email</v-icon> </v-btn>
        </template>
        <span>Change email</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        <h2>Update Email</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="newEmail"
            label="email"
            prepend-icon="email"
            :rules="emailRules"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmEmailChange"
            class="success mx-1 mt-3"
            :loading="loadingConfirm"
            ><v-icon>done</v-icon><span> Confirm change</span></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String
    },
    email: {
      type: String
    },
  },
  data() {
    return {
      newEmail: "",
      emailRules: [
        v => !!v || "This field is required",
        v => v.length >= 6 || "Minimum length is 6 characters",
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'        
      ],
      loadingConfirm: false,
      loadingCancel: false,
      dialog: false
    };
  },
  methods: {
    async setEmail() {
      this.newEmail = this.email;
    },
    confirmEmailChange() {
      if (this.$refs.form.validate()) {
        this.loadingConfirm = true;
        let updateBody = {
          cartId: this.cartId,
          email: this.newEmail,
        }
        cartApi
          .postUpdatePaymentInformation(updateBody)
          .then(() => {
            this.loadingConfirm = false;
            this.dialog = false;
            this.$emit("emailChanged");
          });
      }
    }
  }
};
</script>
